module.exports = __webpack_public_path__ + "img/mozzo 3.e41cc54d.jpeg";